import { render, staticRenderFns } from "./SupplierTender.vue?vue&type=template&id=4548cf94&scoped=true&"
import script from "./SupplierTender.vue?vue&type=script&lang=js&"
export * from "./SupplierTender.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTender.vue?vue&type=style&index=0&id=4548cf94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4548cf94",
  null
  
)

export default component.exports